module.exports = __webpack_public_path__ + "assets/tinylogo_2.svg";